module.exports = __webpack_public_path__ + "static/media/img77_R.94bb2b70.jpg";